import { FC, useState } from 'react'
import { ReactComponent as GuardIcon } from '@/assets/icons/guard.svg'
import { Input, Form } from 'antd'
import i18n, { useTranslation } from '@/services/i18n'
import Modal from '@/components/Modal'
import { validate, genVerificationCode } from '@/utils/validator'
import styles from './index.module.scss'

const verificationCodeRule = genVerificationCode()

interface GAModalContentProps {
  onChange: (val: string) => string
}

const GAModalContent: FC<GAModalContentProps> = ({ onChange }) => {
  const { t } = useTranslation()
  const [errMsg, setErrMsg] = useState('')
  const handleChange = (evt: any) => {
    const err = onChange?.(evt.target.value)
    setErrMsg(err)
  }
  return (
    <Form.Item validateStatus={errMsg && 'error'} help={errMsg} className={styles.formItem}>
      <Input placeholder={t('ga.placeholder') || ''} onChange={handleChange} />
    </Form.Item>
  )
}

const open = (callback: (data: string) => void) => {
  let code = ''
  const modal = Modal.confirm({
    content: (
      <GAModalContent
        onChange={val => {
          const { isValid, errMsg } = validate(val, [verificationCodeRule])
          code = val
          modal.update({
            okButtonProps: {
              disabled: !isValid,
            },
          })
          return errMsg
        }}
      />
    ),
    icon: <GuardIcon />,
    title: i18n.t('ga.title'),
    closable: true,
    okButtonProps: { disabled: !code },
    onOk: () => {
      callback(code)
    },
    onCancel: () => {
      callback('')
    },
  })
}

export default {
  open,
}
